import _ from 'lodash'

const toCapitalize = (str: string) =>
  str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase()

const getFullname = (firstName: string, lastName: string) =>
  toCapitalize(firstName) + ' ' + toCapitalize(lastName)

const currencyFormatConvertor = (x = '') => {
  x = x.toString()
  x = x?.split('.')[0]
  let lastThree = x.substring(x.length - 3)
  const otherNumbers = x.substring(0, x.length - 3)
  if (otherNumbers != '') lastThree = ',' + lastThree
  const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree
  return res
}

const getQuarterLabel = (quarter: string, fy: string) => {
  const year = _.split(fy, '-')[0]

  if (quarter === '1') {
    return `Q1 (Apr ${year} - June ${year})`
  } else if (quarter === '2') {
    return `Q2 (Jul ${year} - Sep ${year})`
  } else if (quarter === '3') {
    return `Q3 (Oct ${year} - Dec ${year})`
  } else if (quarter === '4') {
    return `Q4 (Jan ${Number(year) + 1} - Mar ${Number(year) + 1})`
  } else {
    return ''
  }
}

const addNewlineBetweenStrings = (stringsList: string[]) => {
  let newLineString = ''
  _.forEach(stringsList, (st) => {
    if (!_.isEmpty(st))
      if (stringsList.indexOf(st) === stringsList.length - 1)
        newLineString = `${newLineString}${st}`
      else newLineString = `${newLineString}${st}\n`
  })
  return newLineString
}

const titleCase = (sentance: string) => {
  return sentance
    ?.toLowerCase()
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}

// ! Keeping this for ref
// const getName = (name: string) => {
//   if (name?.length > 14) {
//     const t = name?.split(' ')
//     if (t?.length > 1) {
//       return (
//         toCapitalize(t?.[0]).slice(0, 14) +
//         ' ' +
//         t?.[1]?.charAt(0)?.toUpperCase()
//       )
//     } else if (t?.length > 0) {
//       return toCapitalize(t?.[0]).slice(0, 14)
//     }
//     return toCapitalize(t?.[0]).slice(0, 14)
//   } else {
//     return toCapitalize(name)
//   }
// }

const getName = (name: string) => {
  if (name?.length > 14) {
    const t = name?.split(' ')
    if (t?.length > 1) {
      return (
        toCapitalize(t?.[0]).slice(0, 14) +
        ' ' +
        t?.[1]?.charAt(0)?.toUpperCase()
      )
    } else if (t?.length > 0) {
      return titleCase(name)
    }
    return titleCase(name)
  } else {
    return titleCase(name)
  }
}

export {
  toCapitalize,
  getFullname,
  currencyFormatConvertor,
  getQuarterLabel,
  addNewlineBetweenStrings,
  titleCase,
  getName,
}
